import axios from 'axios';

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8081/api'
});

// Interceptor koji "lepi" token na svaki zahtev
API.interceptors.request.use((config) => {
    const token = sessionStorage.getItem('token');
    console.log("Šaljem token:", token); // Ako je ovde null, React ga ne vidi
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});


export default API;